import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleVsExcel from "../pages/article/vs-excel";
import ArticleVsNotion from "../pages/article/vs-notion";
import ArticleSevenWays from "../pages/article/seven-ways";
import ArticleWhyFail from "../pages/article/why-fail";
import ArticleEcommerce from "../pages/article/ecommerce";
import ArticleAffiliate from "../pages/article/affiliate-marketing";
import ArticleExplainedFuture from "../pages/article/explained-future";
import ArticleAutomation from "../pages/article/automation-guide";
import ArticlePrivacy from "../pages/article/privacy-security";
import ShoppingGuide from "../pages/article/shopping-guide";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/what-is-acbuyspreadsheet", element: <ArticlePage /> },
  { path: "/shopping-guide", element: <ShoppingGuide /> },
  { path: "/acbuyspreadsheet-vs-excel", element: <ArticleVsExcel /> },
  { path: "/acbuyspreadsheet-vs-notion", element: <ArticleVsNotion /> },
  { path: "/7-ways-acbuyspreadsheet-improves-workflow", element: <ArticleSevenWays /> },
  { path: "/why-spreadsheet-systems-fail", element: <ArticleWhyFail /> },
  { path: "/acbuyspreadsheet-for-ecommerce", element: <ArticleEcommerce /> },
  { path: "/acbuyspreadsheet-for-affiliate-marketing", element: <ArticleAffiliate /> },
  { path: "/acbuyspreadsheet-explained-future", element: <ArticleExplainedFuture /> },
  { path: "/acbuyspreadsheet-automation-guide", element: <ArticleAutomation /> },
  { path: "/acbuyspreadsheet-privacy-security", element: <ArticlePrivacy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;